import { IIconsProps } from "components/Icons/icons.model"

const CustomDoubleLeft = (props: IIconsProps) => {
    return (
        <i id={props.id} className="fa-solid fa-angles-left" style={{ fontSize: props.fontSize, color: props.color, ...props.style }} />
    )
}

export default CustomDoubleLeft;